import { render, staticRenderFns } from "./SpecialSituationReport.vue?vue&type=template&id=2a98b4b3&scoped=true"
import script from "./SpecialSituationReport.vue?vue&type=script&lang=js"
export * from "./SpecialSituationReport.vue?vue&type=script&lang=js"
import style0 from "./SpecialSituationReport.vue?vue&type=style&index=0&id=2a98b4b3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a98b4b3",
  null
  
)

export default component.exports